export async function getUser(base, userId, auth) {
    const result = await fetch(`${base}/api/v1/users/me`, {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${auth}`,
        }
    });
    return result.json();
}
//# sourceMappingURL=user.js.map